export default __webpack_public_path__ + "static/advance-c2aa022c8be9af8690b3286e2f04fc6b.mp4";